import { EnvGlobalsHandler } from "@goodgamestudios/core";
import { ExternalInterface } from "@goodgamestudios/createjs-utilities";

export const AUTO_TABLE= 'auto';
class AntiCheating {
    private _table: string = "";
    private locked: boolean = false;
    private unloaded: boolean = false;
    private storage: Storage;

    public constructor() {
        this.addUnloadEvents();
        try{
            this.storage = window.localStorage;
            if(!this.storage) {
                this.storage = new MockLocalStorage();
            }
        } catch(e) {
            this.storage = new MockLocalStorage();
        }
    }

    private addUnloadEvents(): void {
        window.addEventListener("beforeunload", () => {
            this.unload();
        });

        window.addEventListener("unload", () => {
            this.unload();
        });
    }

    private unload(): void {
        if (!this.unloaded) {
            this.unloaded = true;

            if (this.locked) {
                this.unlockTable();
            }
        }
    }

    private localStorageKey(attributeName: string): string {
        return [
            "ggs.gameData",
            EnvGlobalsHandler.globals.gameId,
            EnvGlobalsHandler.globals.networkId,
            "pc",
            attributeName
        ].join("_");
    }

    private hasAttribute(attributeName: string): boolean {
        return !!this.storage.getItem(this.localStorageKey(attributeName));
    }

    private getAttribute(attributeName: string): string {
        return this.storage.getItem(this.localStorageKey(attributeName));
    }

    private setAttribute(attributeName: string, value: string): void {
        this.storage.setItem(this.localStorageKey(attributeName), value);
    }

    private deleteAttribute(attributeName: string): void {
        this.storage.removeItem(this.localStorageKey(attributeName));
    }

    public isTableFree(): boolean {
        if (this._table === "") {
            return false;
        }

        if(this._table == AUTO_TABLE) {
            return true;
        }

        let views: number = 0;

        if (this.hasAttribute(this._table)) {
            views = parseInt(this.getAttribute(this._table));
        }

        return views === 0;
    }

    public lockTable(): void {
        if (this._table === "") {
            return;
        }

        let views: number = 0;

        if (this.hasAttribute(this._table)) {
            views = parseInt(this.getAttribute(this._table));
        }

        views++;

        this.locked = true;
        this.setAttribute(this._table, views.toString());
    }

    public unlockTable(): void {
        if (this._table === "") {
            return;
        }

        let views: number = 0;

        if (this.hasAttribute(this._table)) {
            views = parseInt(this.getAttribute(this._table));
        }

        if (views > 0) {
            views--;
        }

        this.locked = false;

        if (views > 0) {
            this.setAttribute(this._table, views.toString());
        } else {
            this.deleteAttribute(this._table);
        }
    }

    public set table(value: string) {
        this._table = value || "";
    }

    public get table(): string {
        return this._table;
    }
}

class MockLocalStorage implements Storage {
    public get length() {
        return 1;
    }
    public clear(): void {}
    public getItem(key: string): string {
        return ExternalInterface.call("ggsGetStoredGameData", key);
    }
    public key(index: number): string {
        return "";
    }
    public removeItem(key: string): void {
        ExternalInterface.call("ggsRemoveStoredGameData", key);
    }
    public setItem(key: string, value: string): void {
        ExternalInterface.call("ggsStoreGameData", key, value);
    }
}

export const antiCheating = new AntiCheating();
